import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "mt-20" }
const _hoisted_3 = { class: "van-cell" }
const _hoisted_4 = { style: {"padding-bottom":"1.5rem"} }
const _hoisted_5 = { class: "mt-20" }
const _hoisted_6 = { class: "mt-20" }
const _hoisted_7 = {
  class: "flex-n fac w-full",
  style: {"padding":"0 1rem"}
}
const _hoisted_8 = { class: "flex-1" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["id"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "tab-way" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { style: {"padding-bottom":"1.5rem"} }
const _hoisted_15 = { class: "submitcontent" }

import {onBeforeUnmount, onMounted, ref, watch, shallowRef,nextTick} from "vue";
import ZCell from "@/components/ZCell/ZCell.vue";
import ZCard from "@/components/ZCard/ZCard.vue";
import TimePicker from "@/components/TimePicker/TimePicker.vue";
import UploadImage from "@/components/UploadImage/UploadImage.vue";
import {solarToLunar} from '@/assets/ts/getLunarBySolar'
import '@wangeditor/editor/dist/css/style.css';
import {Editor} from '@wangeditor/editor-for-vue';
import obituaryApi from "@/utils/Api/Obituary";
import {showToast} from 'vant'
import {useRoute} from "vue-router";
import weChatObituaryApi from "@/utils/Api/WeChatObituary";
import router from "@/router";


export default /*@__PURE__*/_defineComponent({
  __name: 'create',
  setup(__props) {

const route=useRoute();
onMounted(() => {
  document.title = '编辑讣告';
  getMusicList();
  getDetail();
})

const form = ref({
  //逝者信息
  deceasedname: '', //逝者姓名
  sex: 0, //性别
  birthdate: '', //出生日期
  deathtime: '', //逝世日期
  deathage: '', //逝者年龄
  deathimg: [], //遗像上传

  //家属信息
  username: '', //家属姓名
  telphone: '', //家属电话
  callrelation: '', //逝者称呼关系

  //讣告信息
  backgroupmusicid: '', //讣告音乐
  music: '', //音乐名称
  obituarytemplateid: 1, //模版
  obituarytemplate: 0,//模版目前定死
  obituarytemplateName: '',
  obituarycontent: '', //讣告正文
  obituaryTitle: '',//讣告标题
  obituarySignature: '',//讣告落款

  //生前照片
  deathInfoImgList: [],
  //讣告服务
  serviceprice: '', //服务价格
  remark: '', //信息备注
})

//获取详情
const getDetail=()=>{
  weChatObituaryApi.detail(route.query.id).then(res=>{

     form.value={
      ...res.data.obituaryBaseInfo,
      obituaryBaseInfoId:res.data.obituaryBaseInfo.id,
      ...res.data.deathinfo,
      deathinfoId:res.data.deathinfo.id,
      ...res.data.obituaryfamilymember,
      obituaryfamilymemberId:res.data.obituaryfamilymember.id,
      ...res.data.deathPhoto,
      ...res.data.obituarServiceModel,
      obituarServiceModelId:res.data.obituarServiceModel.id,
      deathimg:res.data.deathinfo.deathimg?[res.data.deathinfo.deathimg]:[]
    }
    console.log('form',form.value)
    for(let i in musicList){
      if(musicList[i].id==form.value.backgroupmusicid){
        form.value.music=musicList[i].musicname
        break;
      }
    }
    form.value.obituarytemplateName='默认模板'
    form.value.obituarytemplate=0
    form.value.birthdate=form.value.birthdate.replace(' 00:00:00','');
    form.value.deathtime=form.value.deathtime.replace(' 00:00:00','');

    //自定义
    if(form.value.obituarytemplateid==1){
//使用模板
      writeModelContent()
    }

    console.log(form.value,'213123')
  })
}

watch(() => [form.value.birthdate, form.value.deathtime], (newval) => {
  console.log(23123,form.value.birthdate,form.value.deathtime)
  if (form.value.birthdate.length > 0 && form.value.deathtime.length > 0) {
    const birthdate=form.value.birthdate;
    const date1 = new Date(birthdate), date2 = new Date(form.value.deathtime);
    let y1 = date1.getFullYear(), m1 = date1.getMonth() + 1, d1 = date1.getDate(),
        y2 = date2.getFullYear(), m2 = date2.getMonth() + 1, d2 = date2.getDate();
    console.log(y1, y2, m1, m2, d1, d2)
    if (y1 > y2) {
      //输入有误
      form.value.deathage = '';
    } else {
      if (m2 > m1 || m2 == m1 && d2 >= d1) {
        form.value.deathage = y2 - y1;
      } else {
        form.value.deathage = y2 - y1 - 1;
      }
    }
  } else {
    form.value.deathage = '';
  }
})


//模版
const show = ref(false);


const columns = [
  {text: '默认模版', value: '0'},
];
const isFocus=ref(true);
watch(()=>[form.value.deathtime,form.value.callrelation,form.value.deceasedname,form.value.deathage,form.value.username],()=>{
  isFocus.value=false;
  writeModelContent();
})



//写模版内容
const writeModelContent = () => {

  let d = form.value;
  console.log('deathtime',d.deathtime)
  let deathtime = d.deathtime.split('-');
  let newday = d.deathtime ? new Date(new Date(deathtime).getTime() + 2 * 24 * 60 * 60 * 1000) : '';
  let date1 = d.deathtime ? solarToLunar(deathtime[0], deathtime[1], deathtime[2]).monthStr + solarToLunar(deathtime[0], deathtime[1], deathtime[2]).dayStr : '';
  let date4 = d.deathtime ? deathtime[0] + '年' + deathtime[1] + '月' + deathtime[2] + '日' : ''
  let date2 = newday ? (newday.getFullYear() + '年' + (newday.getMonth() + 1) + '月' + newday.getDate() + '日') : '';
  let date3 = newday ? solarToLunar(newday.getFullYear(), newday.getMonth() + 1, newday.getDate()).monthStr + solarToLunar(newday.getFullYear(), newday.getMonth() + 1, newday.getDate()).dayStr : '';
  form.value.obituarycontent2 = `<div>${d.callrelation || '[称呼关系]'}${d.deceasedname || '[逝者姓名]'}</div><div>      于${(date4) || '[逝世时间]'}农历${date1 || '[逝世时间计算农历]'}去世，享年${d.deathage >= 0 ? d.deathage : '[逝者年龄]'}岁。</div><div>      兹定于${date2 || '[公历(去世第3天出殡，去世当天算1天)]'} ${date3 || '[对应农历]'},举行遗体告别仪式。
      <br/>
      <div>特发此告！</div><div>${d.username || '[家属姓名]'}泣告</div>

      </div>`

}
watch(()=>isFocus.value,(newval)=>{
  if(newval){
    form.value.obituarycontent=form.value.obituarycontent2
  }
})
const onConfirmModule = ({selectedOptions}) => {
  show.value = false;
  form.value.obituarytemplate = selectedOptions[0].text;
}

//音乐选择
const showMusic = ref(false);

let musicList =[{
  id: 1,
  musicname: '音乐1',
  url: 'http://music.163.com/song/media/outer/url?id=1497588709.mp3'
}, {
  id: 2,
  musicname: '音乐2',
  url: 'http://music.163.com/song/media/outer/url?id=1497588709.mp3'
}];

const customFieldName = {
  text: 'musicname',
  value: 'id',
};
//获取音乐
const getMusicList=()=>{
  weChatObituaryApi.getBackGroundMusicList().then(res=>{
    console.log(11)
    musicList=res.data||[]
  })
}
const onConfirmMusic = ({selectedOptions}) => {
  console.log(selectedOptions)
  showMusic.value = false;
  form.value.music = selectedOptions[0].musicname;
  form.value.backgroupmusicid= selectedOptions[0].id;
}
let tempId = ref('');
const playAudio = (id: string) => {
  if (tempId.value != id) {
    if (tempId.value) {
      document.getElementById(tempId.value).pause();
      document.getElementById(tempId.value).currentTime = 0;
    }
    tempId.value = id;
    document.getElementById(id).play();

  } else {
    document.getElementById(id).pause();
    tempId.value = '';
  }

}


const editorRef = shallowRef();

onBeforeUnmount(() => {
  const editor = editorRef.value;
  if (editor == null) return
  editor.destroy()
})
// let toolbar: any;
const createdEditor = (editor: any) => {
  editorRef.value = editor;
  console.log('zz')
  writeModelContent();


}


const tabWay = ref(0);
const addLabel = (val: string) => {
  console.log(val)
}
const editorConfig = {
  placeholder: '写下讣文，深痛缅怀 …',
  MENU_CONF: {},
  autoFocus: false,
  readOnly: true,

}
const defaultContent = ref([
  {
    type: 'paragraph',
    children: [
      {text: '', fontFamily: '微软雅黑', fontSize: '16px'}
    ],
    lineHeight: 1.5
  }
])
const changeValue = (num: number) => {
  tabWay.value = num;
  console.log(editorRef.value.isDisabled())
  if (!tabWay.value) {
    editorRef.value.disable()
  } else {
    editorRef.value.enable()
  }
  console.log( editorRef.value.getHtml())

}
const getImgList=(formName:any,data:any)=>{
  console.log(formName,data)
  form.value[formName]=data;
}
//提交
const onSubmit = (values: any) => {
  console.log('submit1', values);
  let _form=form.value;
  weChatObituaryApi.updateOrAdd(1, {
    //讣告服务
    obituaryBaseInfo: {
      id:_form.obituaryBaseInfoId,
      customerId:_form.customerId,
      merchantMemberId:_form.merchantMemberId,
      employeeId: _form.employeeId,
      obituarytemplateid:_form.obituarytemplateid,
      backgroupmusicid:_form.backgroupmusicid,
      obituarycontent: _form.obituarycontent,
      remark: _form.remark,
      obituaryTitle:_form.obituaryTitle,//讣告标题
      obituarySignature:_form.obituarySignature,//讣告落款
    },
    //逝者信息
    deathinfo: {
      id:_form.deathinfoId,
      deceasedname: _form.deceasedname, //逝者姓名
      sex: _form.sex, //性别
      birthdate: _form.birthdate, //出生日期
      deathtime: _form.deathtime, //逝世日期
      deathage: _form.deathage, //逝者年龄
      deathimg: _form.deathimg?.[0], //遗像上传
    },
    //家属信息
    obituaryfamilymember: {
      id:_form.obituaryfamilymemberId,
      username: _form.username, //家属姓名
      telphone: _form.telphone, //家属电话
      callrelation: _form.callrelation, //逝者称呼关系
    },
    deathPhoto: {
      //生前照片
      deathInfoImgList: _form.deathInfoImgList,
    },
    //讣告服务
    obituarServiceModel: {
      id:_form.obituarServiceModelId,
      serviceprice: _form.serviceprice, //服务价格
      remark: _form.remark, //信息备注
    }
  }).then(()=>{
    showToast({
      message:'编辑成功',
      onOpened(){
        router.push('/')
      }
    });
  })
}


return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createBlock(_component_van_form, {
    onSubmit: onSubmit,
    "show-error": "",
    "show-error-message": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ZCard, { title: "逝者信息" }, {
            default: _withCtx(() => [
              _createVNode(ZCell, {
                label: "逝者姓名",
                hiddenArrow: "",
                require: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    modelValue: form.value.deceasedname,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.deceasedname) = $event)),
                    placeholder: "请输入",
                    rules: [{ required: true, message: '请填写逝者姓名' }]
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(ZCell, {
                label: "逝者性别",
                hiddenArrow: "",
                require: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_radio_group, {
                    class: "van-cell",
                    modelValue: form.value.sex,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.sex) = $event)),
                    direction: "horizontal",
                    rules: [{ required: true, message: '请填写逝者性别' }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_radio, { name: 0 }, {
                        default: _withCtx(() => _cache[23] || (_cache[23] = [
                          _createTextVNode("男")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_van_radio, { name: 1 }, {
                        default: _withCtx(() => _cache[24] || (_cache[24] = [
                          _createTextVNode("女")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(ZCell, {
                label: "出生日期",
                require: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(TimePicker, {
                    modelValue: form.value.birthdate,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.birthdate) = $event)),
                    rules: [{ required: true, message: '请填写' }]
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(ZCell, {
                label: "逝世日期",
                require: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(TimePicker, {
                    modelValue: form.value.deathtime,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.deathtime) = $event)),
                    rules: [{ required: true, message: '请填写' }]
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(ZCell, {
                label: "逝者年龄",
                class: _normalizeClass(['cell-input', form.value.deathage!==''?'':'empty']),
                hiddenArrow: "",
                require: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(form.value.deathage !== '' ? form.value.deathage : '自动计算'), 1)
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(ZCell, {
                label: "遗像上传",
                hiddenArrow: "",
                wrap: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(UploadImage, {
                      count: 1,
                      list: form.value.deathimg,
                      "aspect-ratio": 4/5,
                      onGetImgList: _cache[4] || (_cache[4] = e=>getImgList('deathimg',e))
                    }, null, 8, ["list"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(ZCard, { title: "家属信息" }, {
            default: _withCtx(() => [
              _createVNode(ZCell, {
                label: "家属姓名",
                hiddenArrow: "",
                require: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    modelValue: form.value.username,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.username) = $event)),
                    placeholder: "请输入",
                    rules: [{ required: true, message: '请填写' }]
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(ZCell, {
                label: "手机号码",
                hiddenArrow: "",
                require: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    modelValue: form.value.telphone,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.telphone) = $event)),
                    type: "tel",
                    maxlength: "11",
                    placeholder: "请输入",
                    rules: [{ required: true, message: '请填写' }]
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(ZCell, {
                label: "关系",
                hiddenArrow: "",
                require: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    modelValue: form.value.callrelation,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.callrelation) = $event)),
                    placeholder: "请输入",
                    rules: [{ required: true, message: '请填写' }]
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(ZCard, { title: "讣告信息" }, {
            default: _withCtx(() => [
              _createVNode(ZCell, {
                label: "讣告模板",
                class: _normalizeClass(['cell-input',form.value.obituarytemplate!==''?'':'empty'])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    modelValue: form.value.obituarytemplateName,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.obituarytemplateName) = $event)),
                    readonly: "",
                    placeholder: "请选择",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (show.value = true))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_popup, {
                    show: show.value,
                    "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((show).value = $event)),
                    round: "",
                    position: "bottom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_picker, {
                        columns: columns,
                        onCancel: _cache[10] || (_cache[10] = ($event: any) => (show.value = false)),
                        onConfirm: onConfirmModule
                      })
                    ]),
                    _: 1
                  }, 8, ["show"])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(ZCell, {
                label: "讣告音乐",
                class: _normalizeClass(['cell-input',form.value.backgroupmusicid!==''?'':'empty'])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    modelValue: form.value.music,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.music) = $event)),
                    readonly: "",
                    placeholder: "请选择",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (showMusic.value = true))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_popup, {
                    show: showMusic.value,
                    "onUpdate:show": _cache[15] || (_cache[15] = ($event: any) => ((showMusic).value = $event)),
                    round: "",
                    position: "bottom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_picker, {
                        columns: _unref(musicList),
                        onCancel: _cache[14] || (_cache[14] = ($event: any) => (showMusic.value = false)),
                        "columns-field-names": customFieldName,
                        onConfirm: onConfirmMusic
                      }, {
                        option: _withCtx((data) => [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(data.musicname), 1),
                            _createElementVNode("div", {
                              onClick: ($event: any) => (playAudio('audio'+data.id))
                            }, [
                              _createVNode(_component_van_icon, {
                                size: "2rem",
                                color: _unref(tempId)!==('audio'+data.id)?'#0087ff':'#ff6666',
                                name: (_unref(tempId)!==('audio'+data.id)?'play':'pause')+'-circle-o'
                              }, null, 8, ["color", "name"])
                            ], 8, _hoisted_9),
                            _createElementVNode("audio", {
                              id: 'audio'+data.id
                            }, [
                              _createElementVNode("source", {
                                src: data.musicpath
                              }, null, 8, _hoisted_11)
                            ], 8, _hoisted_10)
                          ])
                        ]),
                        _: 1
                      }, 8, ["columns"])
                    ]),
                    _: 1
                  }, 8, ["show"])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_van_field, {
                class: "obituary-title",
                modelValue: form.value.obituaryTitle,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.obituaryTitle) = $event)),
                "input-align": "center",
                placeholder: "讣告标题"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: _normalizeClass([tabWay.value==0?'choose':'']),
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (changeValue(0)))
                }, "使用模板", 2),
                _createElementVNode("div", {
                  class: _normalizeClass([tabWay.value==1?'choose':'']),
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (changeValue(1)))
                }, "自定义", 2)
              ]),
              (!isFocus.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    id: "editor",
                    innerHTML: form.value.obituarycontent2,
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (isFocus.value=true))
                  }, null, 8, _hoisted_13))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_unref(Editor), {
                id: "editor",
                modelValue: form.value.obituarycontent,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((form.value.obituarycontent) = $event)),
                defaultConfig: editorConfig,
                "default-content": defaultContent.value,
                mode: "default",
                onOnCreated: createdEditor
              }, null, 8, ["modelValue", "default-content"]), [
                [_vShow, isFocus.value]
              ]),
              _createVNode(_component_van_field, {
                class: "obituary-bottom",
                modelValue: form.value.obituarySignature,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.value.obituarySignature) = $event)),
                "input-align": "right",
                placeholder: "落款"
              }, null, 8, ["modelValue"]),
              _createVNode(ZCell, {
                label: "生前照片",
                hiddenArrow: "",
                wrap: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(UploadImage, {
                      list: form.value.deathInfoImgList,
                      onGetImgList: _cache[22] || (_cache[22] = e=>getImgList('deathInfoImgList',e))
                    }, null, 8, ["list"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _cache[26] || (_cache[26] = _createElementVNode("div", { style: {"height":"12.5rem"} }, null, -1)),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_van_button, {
            round: "",
            block: "",
            class: "primary-btn",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => _cache[25] || (_cache[25] = [
              _createTextVNode(" 提交 ")
            ])),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})